"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const adminClient_1 = require("client/adminClient");
const useDebounce_1 = __importDefault(require("hooks/useDebounce"));
const HelperUtils_1 = require("utils/HelperUtils");
const Button_1 = __importDefault(require("components/design-system/Button"));
const ProfileType_1 = __importDefault(require("components/design-system/ProfileType"));
const Table_1 = __importDefault(require("components/design-system/table/Table"));
const Checkbox_1 = __importDefault(require("components/shared/Checkbox"));
const LoadingComponent_1 = __importDefault(require("components/shared/LoadingComponent"));
const PaginationModule_1 = __importDefault(require("components/shared/PaginationModule/PaginationModule"));
const SearchBar_1 = __importDefault(require("components/shared/SearchBar"));
const Modal_1 = __importDefault(require("components/shared/modal/Modal"));
const TruncateParagraph_1 = __importDefault(require("src/components/shared/TruncateParagraph"));
const SelectGroupMember = ({ members, setMembers, isReadOnly, setTotalParticipant }) => {
    const [currentParticipant, setCurrentParticipant] = (0, react_1.useState)([]);
    const [listMember, setListMember] = (0, react_1.useState)([]);
    const [modalOpen, setModalOpen] = (0, react_1.useState)(false);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isModalLoading, setIsModalLoading] = (0, react_1.useState)(true);
    const [searchValue, setSearchValue] = (0, react_1.useState)('');
    const [pagination, setPagination] = (0, react_1.useState)(null);
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const { select_all, includes, excludes } = members;
    const debouncedSearchValue = (0, useDebounce_1.default)(searchValue, 1000);
    const checkboxHeader = [{ name: 'checkbox', widthClass: 'w-[56px]' }];
    const tableHeaders = [
        {
            name: (0, HelperUtils_1.getObjectiveLocale)('Participant Group Name'),
            widthClass: 'w-[360px]',
            grow: true
        },
        {
            name: (0, HelperUtils_1.getObjectiveLocale)('Total participants'),
            widthClass: 'w-[160px]',
            useHeaderMargin: false
        },
        { name: '', widthClass: 'w-[160px]' }
    ];
    const getListParticipants = async (additionalParams) => {
        const { data, pagination: paginationData } = await (0, adminClient_1.getTeamsCMSCulture)({
            q: searchValue,
            limit: 10,
            ...additionalParams
        });
        if (data) {
            setCurrentParticipant(data);
            setPagination({
                olderThan: data.length < 10 ? null : paginationData?.next?.olderThan,
                newerThan: paginationData?.prev?.newerThan
            });
        }
        setIsLoading(false);
    };
    const isAllCheckHandler = () => {
        if (select_all) {
            const FilteredLength = currentParticipant.filter((value) => excludes.indexOf(value.id) > -1).length;
            return FilteredLength === 0;
        }
        else {
            const FilteredLength = currentParticipant.filter((value) => includes.indexOf(value.id) > -1).length;
            return FilteredLength === currentParticipant.length;
        }
    };
    const selectMembers = (e, value) => {
        const checked = e.currentTarget.checked;
        if (checked) {
            handleCheckMembers([value.id]);
        }
        else {
            handleUncheckMembers([value.id]);
        }
    };
    const handleCheckMembers = (ids) => {
        const tempIncludes = JSON.parse(JSON.stringify(includes));
        const tempExcludes = JSON.parse(JSON.stringify(excludes));
        if (select_all) {
            const newArray = tempExcludes.filter((value) => ids.indexOf(value) == -1);
            setMembers({ ...members, excludes: newArray });
        }
        else {
            const uniqueIds = new Set([...tempIncludes, ...ids]);
            setMembers({ ...members, includes: [...uniqueIds] });
        }
    };
    const handleUncheckMembers = (ids) => {
        const tempIncludes = JSON.parse(JSON.stringify(includes));
        const tempExcludes = JSON.parse(JSON.stringify(excludes));
        if (select_all) {
            setMembers({ ...members, excludes: tempExcludes.concat(ids) });
        }
        else {
            const newArray = tempIncludes.filter((value) => ids.indexOf(value) == -1);
            setMembers({ ...members, includes: newArray });
        }
    };
    const checkAllHandler = () => {
        const arr = [...currentParticipant].map((v) => {
            return v.id;
        });
        if (isAllCheckHandler() == true) {
            handleUncheckMembers(arr);
        }
        else {
            handleCheckMembers(arr);
        }
    };
    const isSelected = (user) => {
        if (select_all) {
            return excludes.indexOf(user.id) === -1 ? true : false;
        }
        else {
            return includes.indexOf(user.id) > -1 ? true : false;
        }
    };
    const changePage = (type) => {
        if (type === 'next') {
            getListParticipants({ olderThan: pagination?.olderThan });
            setCurrentPage(currentPage + 1);
        }
        else {
            getListParticipants({ newerThan: pagination?.newerThan });
            setCurrentPage(currentPage - 1);
        }
    };
    const getListMember = async (id) => {
        setIsModalLoading(true);
        const { data } = await (0, adminClient_1.getTeamsIdCMSCulture)(id);
        if (data) {
            setListMember(data?.userDetail);
            setIsModalLoading(false);
        }
    };
    (0, react_1.useEffect)(() => {
        getListParticipants();
        setCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchValue]);
    (0, react_1.useEffect)(() => {
        setTotalParticipant(includes.length);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [includes]);
    return (react_1.default.createElement("div", { className: "mt-[24px]" },
        isLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SearchBar_1.default, { fullWidth: true, placeholder: "Search group", onChange: (e) => setSearchValue(e.target.value), iconClass: "top-1/3", customClass: "mb-[16px]" }),
            react_1.default.createElement(Table_1.default, { headers: [...(isReadOnly ? [] : checkboxHeader), ...tableHeaders], headerCheckbox: {
                    checked: isAllCheckHandler(),
                    onClick: checkAllHandler,
                    disabled: false
                }, fixedLeftCount: isReadOnly ? 1 : 2 }, currentParticipant?.map((participant, index) => (react_1.default.createElement(Table_1.default.Row, { key: `table-row-${index}` },
                !isReadOnly && (react_1.default.createElement(Table_1.default.Column, { key: "table-column-0" },
                    react_1.default.createElement(Checkbox_1.default, { id: `checkbox-${participant?.id}`, name: `checkbox-${participant?.id}`, dataCy: `checkbox-${participant?.id}`, checked: isSelected(participant), onChange: (e) => selectMembers(e, participant), disabled: isReadOnly }))),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 0 : 1}` },
                    react_1.default.createElement(TruncateParagraph_1.default, { className: "typography-h300 text-n-900" }, participant?.name)),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 1 : 2}` },
                    react_1.default.createElement("div", { className: "flex justify-end w-full" },
                        react_1.default.createElement("p", { className: "text-n-900" }, participant?.userCount))),
                react_1.default.createElement(Table_1.default.Column, { key: `table-column-${isReadOnly ? 2 : 3}` },
                    react_1.default.createElement(Button_1.default.Tertiary, { onClick: () => {
                            setModalOpen(true);
                            getListMember(participant?.id);
                        } }, (0, HelperUtils_1.getObjectiveLocale)('View Members'))))))),
            react_1.default.createElement("div", { className: "flex justify-end w-full mt-[12px]" },
                react_1.default.createElement(PaginationModule_1.default, { pageNumber: currentPage, handlePrev: () => changePage('prev'), handleNext: () => changePage('next'), hasMore: pagination?.olderThan !== null })))),
        modalOpen && (react_1.default.createElement(Modal_1.default, { className: "w-[400px]", maxHeight: 488, title: (0, HelperUtils_1.getObjectiveLocale)('Members'), withCloseIcon: true, eventOnClickClose: () => setModalOpen(false), withFooter: false, contentClass: "overflow-auto" }, isModalLoading ? (react_1.default.createElement(LoadingComponent_1.default, null)) : (listMember.length > 0 &&
            listMember.map((member, index) => (react_1.default.createElement(ProfileType_1.default, { key: index, user: member, title: member?.name, subtitle: member?.jobTitle || '-', size: 32, titleClassName: "typography-h400", subtitleClassName: "typography-h100" }))))))));
};
exports.default = SelectGroupMember;
